import { HttpMethod, RequestOptions, useUserOrKioskRequest } from "../../common/lib/fetch";

const useReceivingBackToBayDirections = (stagedPurchaseOrderId: string, options: RequestOptions) =>
  useUserOrKioskRequest<void>({
    method: HttpMethod.POST,
    path: `/api/stagedPurchaseOrders/${stagedPurchaseOrderId}/backToBayDirections`
  }, options);

export default useReceivingBackToBayDirections;
